var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37435 14.8542L9.99935 13.2708L12.6243 14.875L11.9368 11.875L14.2493 9.875L11.2077 9.60417L9.99935 6.77083L8.79102 9.58333L5.74935 9.85417L8.06185 11.875L7.37435 14.8542ZM4.85352 18.3333L6.20768 12.4792L1.66602 8.54167L7.66602 8.02083L9.99935 2.5L12.3327 8.02083L18.3327 8.54167L13.791 12.4792L15.1452 18.3333L9.99935 15.2292L4.85352 18.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarDark);
export default __webpack_public_path__ + "static/media/starDark.90eddca08df7a2b57f9fa8d0b5bb3dce.svg";
export { ForwardRef as ReactComponent };